import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles";
export function BaseLogoCircle(t0) {
  const $ = _c(14);
  let className;
  let rest;
  let square;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      square,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = square;
    $[4] = t1;
  } else {
    className = $[1];
    rest = $[2];
    square = $[3];
    t1 = $[4];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[5] !== size) {
    t2 = {
      width: size,
      height: size
    };
    $[5] = size;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== square) {
    t3 = square ? <><path d="M0 0H24V24H0V0Z" fill="white" /><path d="M5.4 6.6C5.4 5.937258 5.937258 5.4 6.6 5.4H17.4C18.062742 5.4 18.6 5.937258 18.6 6.6V17.4C18.6 18.062742 18.062742 18.6 17.4 18.6H6.6C5.937258 18.6 5.4 18.062742 5.4 17.4V6.6Z" fill="#0700FF" /></> : <><circle cx={12} cy={12} fill="white" r={12} /><path d="M5.4 6.6C5.4 5.937258 5.937258 5.4 6.6 5.4H17.4C18.062742 5.4 18.6 5.937258 18.6 6.6V17.4C18.6 18.062742 18.062742 18.6 17.4 18.6H6.6C5.937258 18.6 5.4 18.062742 5.4 17.4V6.6Z" fill="#0700FF" /></>;
    $[7] = square;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== className || $[10] !== rest || $[11] !== t2 || $[12] !== t3) {
    t4 = <svg className={className} style={t2} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t3}</svg>;
    $[9] = className;
    $[10] = rest;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}
export function BaseLogoCircleMonochrome(t0) {
  const $ = _c(18);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      fill: t2,
      fillAttribute: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const size = t1 === undefined ? 24 : t1;
  const fill = t2 === undefined ? "current" : t2;
  const fillAttribute = t3 === undefined ? "currentColor" : t3;
  let t4;
  if ($[6] !== size) {
    t4 = {
      width: size,
      height: size
    };
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== fill) {
    t5 = fillVariants({
      fill
    });
    $[8] = fill;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== fillAttribute || $[11] !== t5) {
    t6 = <path className={t5} d="M5.4 6.6C5.4 5.937258 5.937258 5.4 6.6 5.4H17.4C18.062742 5.4 18.6 5.937258 18.6 6.6V17.4C18.6 18.062742 18.062742 18.6 17.4 18.6H6.6C5.937258 18.6 5.4 18.062742 5.4 17.4V6.6Z" fill={fillAttribute} fillRule="evenodd" />;
    $[10] = fillAttribute;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== className || $[14] !== rest || $[15] !== t4 || $[16] !== t6) {
    t7 = <svg className={className} style={t4} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t6}</svg>;
    $[13] = className;
    $[14] = rest;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}